import * as fromDatatype from '../datatype-library';

export interface bl_fi_item_company_link_import_file_helper_RowInterface {
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;

    //other fields:
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_validate_error: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_validate_error: fromDatatype.VarcharDatatypeInterface;
    item_company_link_exist_guid: fromDatatype.GuidDataFieldInterface;
    item_company_link_guid: fromDatatype.GuidDataFieldInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    validated: boolean;
    processed: boolean;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_item_company_link_import_file_helper_RowClass implements bl_fi_item_company_link_import_file_helper_RowInterface {
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;

    //other fields:
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_validate_error: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_validate_error: fromDatatype.VarcharDatatypeInterface;
    item_company_link_exist_guid: fromDatatype.GuidDataFieldInterface;
    item_company_link_guid: fromDatatype.GuidDataFieldInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    validated: boolean;
    processed: boolean;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}